var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-form" }, [
    _c(
      "form",
      {
        staticClass: "grid",
        attrs: { novalidate: "" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submit($event)
          }
        }
      },
      [
        _vm._t("intro"),
        _vm._v(" "),
        _c("div", { staticClass: "grid__row" }, [
          _c("div", { staticClass: "grid__col grid__col--100" }, [
            _c(
              "label",
              { staticClass: "reader-only", attrs: { for: "LoginUsername" } },
              [_vm._v(_vm._s(_vm.usernamePlaceholder))]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.username,
                  expression: "username",
                  modifiers: { trim: true }
                },
                {
                  name: "validate",
                  rawName: "v-validate.disable",
                  value: _vm.usernameValidationRules,
                  expression: "usernameValidationRules",
                  modifiers: { disable: true }
                }
              ],
              class: { "input--invalid": _vm.errors.has("LoginUsername") },
              attrs: {
                autocomplete: "username",
                autofocus: "",
                "data-e2e": "login-form.account-id",
                id: "LoginUsername",
                name: "LoginUsername",
                type: "text",
                "aria-label": _vm.usernamePlaceholder,
                placeholder: _vm.usernamePlaceholder
              },
              domProps: { value: _vm.username },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.username = $event.target.value.trim()
                },
                blur: function($event) {
                  _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.has("LoginUsername")
              ? _c("span", { staticClass: "error-message" }, [
                  _vm._v(_vm._s(_vm.errors.first("LoginUsername")))
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid__row" }, [
          _c("div", { staticClass: "grid__col grid__col--100" }, [
            _c(
              "label",
              { staticClass: "reader-only", attrs: { for: "LoginPassword" } },
              [_vm._v("Password")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.password,
                  expression: "password",
                  modifiers: { trim: true }
                },
                {
                  name: "validate",
                  rawName: "v-validate.disable",
                  value: "required",
                  expression: "'required'",
                  modifiers: { disable: true }
                }
              ],
              class: { "input--invalid": _vm.errors.has("LoginPassword") },
              attrs: {
                "aria-label": "Password",
                autocomplete: "current-password",
                "data-e2e": "login-form.password-field",
                id: "LoginPassword",
                name: "LoginPassword",
                placeholder: "Password",
                type: "password"
              },
              domProps: { value: _vm.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.password = $event.target.value.trim()
                },
                blur: function($event) {
                  _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.has("LoginPassword")
              ? _c("span", { staticClass: "error-message" }, [
                  _vm._v(_vm._s(_vm.errors.first("LoginPassword")))
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid__row" }, [
          _c("div", { staticClass: "grid__col grid__col--100" }, [
            _c(
              "button",
              {
                staticClass: "submit",
                attrs: { type: "submit", disabled: _vm.isAwaitingResponse }
              },
              [_vm._v("Login")]
            )
          ])
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }